module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-18.1d1036c5.png";